import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList } from '@/types/common'
import { IOConfig } from '@/types/controller'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchIOConfig(
  interfaceId: number,
  address: number,
  type: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<IOConfig>, any> {
  return useQuery(
    [queryKeys.controller, interfaceId, address, type],
    async () => {
      const { data } = await controllerDataConfigApi.getIOConfig(
        interfaceId,
        address,
        type,
      )

      if (!data) return null

      const IoConfigList =
        data.length > 0 &&
        data?.map((item: any) => {
          return {
            id: item.id,
            description: item.description,
            flags: item.flags,
            luTypeProtocolMask: item.luTypeProtocolMask,
            ioTypeMask: item.ioTypeMask,
            config: item.config,
            expression: item.expression,
            interfaceId: item.interfaceId,
          }
        })

      return {
        list: IoConfigList,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchIOConfig
